import { render, staticRenderFns } from "./Lljl.vue?vue&type=template&id=8827b90e&scoped=true&"
import script from "./Lljl.vue?vue&type=script&lang=js&"
export * from "./Lljl.vue?vue&type=script&lang=js&"
import style0 from "./Lljl.vue?vue&type=style&index=0&id=8827b90e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8827b90e",
  null
  
)

export default component.exports